import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'app-modal-back-button',
  templateUrl: './modal-back-button.component.html',
  styleUrls: ['./modal-back-button.component.scss']
})
export class ModalBackButtonComponent {
  @Input() openModal = false;
  @Output() openModalChange = new EventEmitter<boolean>();
  @Output() backFormEvent = new EventEmitter<boolean>();

  isOpenChange(event: boolean): void {
    this.openModalChange.emit(event);
  }

  clickBackForm(): void {
    this.openModalChange.emit(false);
    this.backFormEvent.emit(true);
  }
}
